// Styles for LanguageSelector go here.
import { baseVariables, Modal, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledLanguageSelector = styled.div`
  .modal-main-container {
    &:focus-visible {
      outline: none;
    }
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    @media ${baseVariables.mediaQuery.md} {
      border-radius: ${toRem(14)};
    }
  }
`;

export const StyledModalBody = styled(Modal.Body)`
  display: flex;
  flex-wrap: wrap;

  padding: ${toRem(24)} !important;

  @media ${baseVariables.mediaQuery.lg} {
    padding-bottom: ${toRem(48)} !important;
  }

  .links-wrapper {
    width: 100%;
    flex-wrap: wrap;
  }

  .link-item-wrapper {
    height: ${toRem(40)};
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 0;

    a {
      color: ${baseVariables.color['base10']} !important;
    }
  }

  li:hover {
    background: ${baseVariables.color['neutral10']};
  }

  a:hover {
    text-decoration: none;
    color: ${baseVariables.color['base10']};
  }

  li a {
    min-width: -webkit-fill-available;
  }
`;

export const StyledModalHeader = styled(Modal.Header)`
  height: ${toRem(88)} !important;

  h4 {
    color: ${baseVariables.color['base10']};
  }

  .icon-clear {
    width: ${toRem(32)};
    height: ${toRem(32)};
  }
`;
